module.exports = __webpack_public_path__ + "static/media/MorningStroll.411dbdc0.jpg";